import enquire from 'enquire.js/dist/enquire.min';

function adjustCarouselIndicatorsPosition(slide) {
    const slideImage = slide.querySelector('.s-page-header__background-image .c-image__img'),
        slideImageHeight = slideImage.offsetHeight,
        section = slide.parentNode.parentNode.parentNode,
        carouselIndicators = section.getElementsByClassName('s-page-header__carousel-indicators')[0];

    // console.log('slide:', slide);
    // console.log('slideImage:', slideImage);
    // console.log('slideImageHeight:', slideImageHeight);
    carouselIndicators.style.top = slideImageHeight + 'px';
}

function adjustCarouselIndicatorsPositionOnMutation(mutations) {
    for (let index = 0, max = mutations.length; index < max; index++) {
        const mutation = mutations[index];

        if (mutation.type === 'attributes') {
            let isActive = mutation.target.classList.contains('active');

            // if the slide is active, run function
            if (isActive) adjustCarouselIndicatorsPosition(mutation.target);
        }
    }
}

if (document.getElementsByClassName('s-page-header').length) {
    const slides = document.getElementsByClassName('s-page-header__carousel-item'),
        options = {
            attributeFilter: ['class'],
        },
        observer = new MutationObserver(adjustCarouselIndicatorsPositionOnMutation);

    enquire.register('screen and (max-width: 767px)', {
        match: function () {
            // adjust each Carousel Indicators Position after page load
            const firstSlides = document.querySelectorAll('.s-page-header__carousel-item:first-child');
            for (let index = 0; index < firstSlides.length; index++) {
                const firstSlide = firstSlides[index];
                adjustCarouselIndicatorsPosition(firstSlide);
            }

            // stop adjusting position of the carousel indicators
            for (let index = 0; index < slides.length; index++) {
                const slide = slides[index];

                observer.observe(slide, options);
            }
        }, // mobile

        unmatch: function () {
            // start adjusting position of the carousel indicators
            for (let index = 0; index < slides.length; index++) {
                const slide = slides[index];

                observer.disconnect(slide);
            }
        }, // desktop
    });

    // The amount of time to delay between automatically cycling an item
    $('.s-page-header--slider .carousel').carousel({
        interval: 7000,
    });
}



// WEBPACK FOOTER //
// ./scripts/routes/sections/page-header.js